import request from '@/utils/request'

export function login(form) {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data: form
  })
}

export function logout() {
  return request({
    url: '/api/auth/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/api/auth/getCurrentUser',
    method: 'post'
  })
}

export function changePassword(query) {
  return request({
    url: '/api/auth/changePassword',
    method: 'post',
    data: query
  })
}





// WEBPACK FOOTER //
// ./src/api/login.js